export const createCase: CMx.CreateCaseState = {
  organization: null,
  isDrawerOpen: false,
  isOpen: false,
  activeCaseRun: {} as CMxAPI.CaseRunV2,
  notesSpecialty: [],
  notesSpecialtyLoading: false
};
